import { ThemeType } from '@localstack/constants';
import { Theme } from '@mui/material';

export const isDarkMode = (theme: Theme): boolean => theme.palette.mode === ThemeType.DARK;
